const INIT_STORE = '@@INIT_STORE';
const SET_STORE = '@@SET_STORE';

const initialState = {};

function initStore() {
    return {
        type: INIT_STORE
    }
}

function applyInitStore() {
    return {}
}

function setStore(info) {
    return {
        type: SET_STORE,
        info
    }
}

function applySetStore(state, action) {
    const { info } = action;
    return {
        ...state,
        info
    }
}

function reducer(state = initialState, action) {
    switch(action.type) {
        default:
            return state;
        case INIT_STORE:
            return applyInitStore();
        case SET_STORE:
            return applySetStore(state, action);
    }
}

const actionCreator = {
    initStore,
    setStore
};

export {actionCreator as storeActions};

export default reducer;